import Keycloak, { KeycloakConfig } from 'keycloak-js'

const config: KeycloakConfig = {
  url: import.meta.env.VITE_API_AUTH_BASE_URL,
  realm: import.meta.env.VITE_API_AUTH_REALM,
  clientId: import.meta.env.VITE_API_AUTH_CLIENT_ID,
}

const keycloak: Keycloak = new Keycloak(config)

export default keycloak
